<template>
  <div class="main-occurrence-grid">
    <!-- Barra de filtros e ações -->
    <div class="d-flex justify-content-between pt-1">
      <div class="d-inline-flex align-items-center justify-content-start">
         <div v-if="occurrences.originalData?.length" class="d-inline-flex align-items-start" style="width: 350px;">
          <div class="w-100 mb-2 mr-3">
            <b-input-group size="sm" class="search-input-group w-100">
              <b-input-group-prepend is-text>
                <b-icon icon="search"></b-icon>
              </b-input-group-prepend>
              <b-form-input v-model="occurrences.search" type="search" :placeholder="$t('search')" @update="search"></b-form-input>
            </b-input-group>
          </div>

           <div class="d-inline-flex" style="width: 200px;">
             <b-button class="btn-filter-reset mr-3 w-100" size="sm" variant="outline-warning" @click="resetAllFilters">
               {{ $t('resetar-filtros') }}
             </b-button>
           </div>
   
         </div>
  
        <div class="switchGroup">
          <label>{{ $t('grupo-selecionados') }}</label>
          <div>
            <b-form-checkbox :disabled="wait" v-model="openedOccurrence" name="check-button-atividadesusuario" switch @input="changeOccurrenceTypes()">
              {{ $t('abertas') }} </b-form-checkbox>
            <Counter :value="counter.open" />
          </div>
          <div>
            <b-form-checkbox :disabled="wait" v-model="canceledOccurrence" name="check-button-atividadesusuario" switch @input="changeOccurrenceTypes()">
              {{ $t('canceladas') }} </b-form-checkbox>
            <Counter :value="counter.canceled" />
          </div>
          <div>
            <b-form-checkbox :disabled="wait" v-model="closedOccurrence" name="check-button-atividadesusuario" switch @input="changeOccurrenceTypes()">
              {{ $t('fechadas') }} </b-form-checkbox>
            <Counter :value="counter.closed" />
          </div>
        </div>
      </div>

      <div class="d-inline-flex align-items-center">
        <div class="ml-1 d-flex align-items-center">
          <div>
            <search-date-picker ref="datepicker" range 
              v-model="filters.range" 
              :lang="filters.lang" 
              :shortcuts="filters.shortcuts" 
              class="custom-date" 
              type="date" 
              format="DD/MM/YYYY" placeholder="Intervalo da busca" 
              range-separator=" até " 
              @input="loadOccurrenceByTime"
              @clear="() => { setDefaultRangeFilter(); loadOccurrenceByTime();}"  
              >
              <template v-slot:input="slotProps">
                <input type="text" v-bind="slotProps.props" v-on="slotProps.events" />
              </template>
  
              <template v-slot:icon-calendar>
                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                  <path d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z" />
                </svg>
              </template>
            </search-date-picker>
          </div>
  
          <div class="checkbox-pgdi" v-if="this.system == 'GDI'">
            <b-form-checkbox v-model="pgdiOccurrence" 
              class="check" 
              :disabled="wait" 
              v-b-tooltip.topright 
              title="Mostrar apenas ocorrências do PGDI" 
              name="check-button-atividadesusuario" 
              switch
              @input="changeOccurrenceTypes()"
            >
            </b-form-checkbox>
            <label>PGDI</label>
          </div>

          <div v-if="occurrences.data?.length" class="reportField ml-3">
            <b-button variant="link" class="p-0" @click="showOccurrenceCharts" v-b-tooltip.hover :title="$t('graficos-ocorrencias')">
              <b-icon icon="arrow-up-right-square" style="color: #17a2b8;"></b-icon>
            </b-button>
          </div>

          <div v-if="occurrences.originalData?.length" class="reportField ml-3">
            <b-button variant="link" class="p-0" @click="showModalTableColumns" :title="$t('configurar-colunas')">
              <b-icon icon="table" style="color: #ff7100;"></b-icon>
            </b-button>
          </div>
  
          <!-- EXPORTA EM PDF -->
          <div v-if="occurrences.originalData?.length" class="reportField">
            <img class="ml-3 printer-button" src="../../assets/pdf-icon.svg" :title="$t('gerar-relatorio')" :alt="$t('imprimir')" @click="openExportSettings('pdf')" />
            <span v-if="loadingPdfReport" class="spinner-border spinner-border-sm spinnerConfig" role="status" aria-hidden="true"></span>
          </div>
          <!-- EXPORTA EM EXCEL -->
          <div v-if="occurrences.originalData?.length" class="reportField">
            <img class="ml-3 printer-button" src="../../assets/excel.png" :title="$t('gerar-relatorio')" :alt="$t('imprimir')" @click="openExportSettings('excel')" />
            <span v-if="loadingExcelReport" class="spinner-border spinner-border-sm spinnerConfig" role="status" aria-hidden="true"></span>
          </div>
        </div>
  
        <!-- Manter -->
        <div class="occurrence-manage-container">
          <button class="mb-1" v-if="showSolvace && this.occurrences.selectedRows.length > 0" @click="sendToSolvace">
            <img src="@/assets/solvaceLogo.png" title="Enviar para o Solvace" />
          </button>
  
          <button class="mb-1" v-if="this.occurrenceSelected.length <= 0 && showSolvace">
            <img src="@/assets/solvaceLogoDisable.png" title="Enviar para o Solvace" />
          </button>
  
          <button class="" v-if="showMassDelete && user.Permissions.fecharocorrenciageral && user.Permissions.fecharocorrenciageral.allowed" :disabled="this.occurrences.selectedRows.length == 0" @click="$bvModal.show('confirmCancelAll')">
            <b-icon-trash-fill class="remove-occurrence-icon" title="Cancelar Ocorrências Selecionadas" />
          </button>
        </div>
      </div>
    </div>

    <div id="table-wrapper" class="table-occurence-">
      <b-overlay id="overlay-background" class="loadingOcc" :show="wait" rounded="sm">
        <ve-table v-if="occurrences.originalData?.length"
          ref="occurrences-table"
          id="occurrences-table"
          :table-data="occurrences.data"
          :columns="occurrences.columns" 
          :column-hidden-option="occurrences.options.columnHiddenOption"
          :column-width-resize-option="occurrences.options.columnWidthResizeOption"
          :checkbox-option="occurrences.options.checkboxOption"
          :sort-option="occurrences.options.sortOption"
          :virtual-scroll-option="occurrences.options.virtualScrollOption"
          :event-custom-option="occurrences.options.eventCustomOption"
          :fixed-header="true"
          :border-x="true"
          :border-y="true"
          :max-height="tableMaxHeight"
          row-key-field-name="id"
          scroll-width="0"
        />

        <div v-show="!occurrences.originalData?.length" class="empty-data">{{$t('sem-dados-para-serem-exibidos')}}</div>
      </b-overlay>
    </div>


    <b-modal id="UntratedOccurrences" size="xl" hide-footer>
      <div slot="modal-title" class="img-slot">
        <img style="width: 33px; height: 33px; margin-right: 10px" src="@/assets/circular138.png"
          alt="salvar_ocorrencia" />
        {{ $t('editor-de-ocorrencia') }}
      </div>
      <ManageAllOccurrences :indicatorInfo="null" :occurrenceInfo="occurrenceSelected" :otherOccurrencesInfo="occurrences.originalData" :reloadOccFunct="loadOccurrence" :showInfluencingParams="true"/>
    </b-modal>

    <b-modal id="confirmCancelAll" size="md" hide-footer :title="$t('confirCancelOccurrence')"
      :no-close-on-backdrop="true">
      <p>Você selecionou <strong>{{this.occurrences.selectedRows.length}}</strong> ocorrências.</p>
      <MessageBox class='msgBox' @motivo="recebe($event)" modelname="confirmCancelAll" :action="cancelMultiplesOccurrences" />
    </b-modal>

    <b-modal id="confirmSendSolvace" ok-variant=danger :title="$t('atencao')" :ok-title="$t('yes')"
      :cancel-title="$t('no')" @ok="confirmSendSolvace">
      {{ $t('confirma-o-envio-solvace1') }} <strong>{{ "[ " + this.occurrences.selectedRows.length + " ]" }}</strong> {{
        $t('confirma-o-envio-solvace2') }}
    </b-modal>

    <b-modal id="occurrence-summary" size="lg" :title="`${$t('informacoes-resumidas')} - ${$t('ocorrencias')}`" centered hide-footer @hidden="onHidden_OccurrenceDigestModal">
      <div v-if="occurrenceToSummarize" class="px-4">
        <div class="row d-flex justify-content-between">
          <div class="col-3">
            <div><strong>Aberta em:</strong></div>
            <div class=" text-nowrap text-truncate">{{ moment(occurrenceToSummarize.creationDate).format('DD/MM/YYYY HH:mm:ss') }}</div>
          </div>
          <div class="col-3">
            <div><strong>Processo:</strong></div>
            <div class=" text-nowrap text-truncate">{{ occurrenceToSummarize.content.processName }}</div>
          </div>
          <div class="col-3">
            <div><strong>Responsável:</strong></div>
            <div class=" text-nowrap text-truncate" v-b-tooltip.hover :title="occurrenceToSummarize.responsibleName">{{ occurrenceToSummarize.responsibleName }}</div>
          </div>
          <div class="col-3">
            <div><strong>Turno:</strong></div>
            <div class=" text-nowrap text-truncate">{{ occurrenceToSummarize.workshiftDescription }}</div>
          </div>
        </div>

        <hr>
        
        <div class="row">
          <div class="col-12 mt-4">
            <h5>Motivos e Ações</h5>
          </div>
        </div>

        <br>

        <div class="row">
          <div class="col-12">
            <div v-for="(reason, rIndex) in summarizedReasons" :key="rIndex">
              <h6>{{ reason.title }}</h6>
              <div v-for="(action, index) in reason.actions" :key="index">
                <div class="d-flex justify-content-between mt-2">
                  <div><strong>Ação: </strong><span class="text-capitalize">{{ action.name }}</span></div>
                  <div><strong>Responsável: </strong><span class="text-capitalize">{{ action.responsible }}</span></div>
                  <div><strong>Status: </strong><span class="text-capitalize">{{ action.status }}</span></div>
                </div>
                <hr>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="occurrence-charts" size="xl" :title="`${$t('informacoes-resumidas')} - ${$t('ocorrencias')}`" centered hide-footer>
      <div v-if="charts.selectedChart" class="d-inline-flex px-4 w-100">
        <div class="occurrence-charts-types d-flex flex-column">
          <h6 class="mb-4">{{ $t('selecao-graficos') }}</h6>
          
          <b-button class="mt-2 mb-4" :variant="charts.selectedChart.type === 'column' ? 'warning' : 'outline-warning'" @click="charts.selectedChart = charts.chartsOptions.find(x => x.type == 'column')">
            <div class="d-flex align-items-center justify-content-between">
              <b-icon icon="bar-chart-fill"></b-icon>
              {{ $t('grafico-barra') }}
            </div>
          </b-button>

          <b-button class="mb-4" :variant="charts.selectedChart.type === 'pizza' ? 'warning' : 'outline-warning'" @click="charts.selectedChart = charts.chartsOptions.find(x => x.type == 'pizza')" >
            <div class="d-flex align-items-center justify-content-between">
              <b-icon icon="pie-chart-fill"></b-icon>
              {{ $t('grafico-pizza') }}
            </div>
          </b-button>

          <b-button class="mb-4" :variant="charts.selectedChart.type === 'stacked' ? 'warning' : 'outline-warning'" @click="charts.selectedChart = charts.chartsOptions.find(x => x.type == 'stacked')">
            <div class="d-flex align-items-center justify-content-between">
              <b-icon icon="bar-chart-fill"></b-icon>
              {{ $t('grafico-barra-empilhada') }}
            </div>
          </b-button>

          <b-button class="mb-4" :variant="charts.selectedChart.type === 'donut' ? 'warning' : 'outline-warning'" @click="charts.selectedChart = charts.chartsOptions.find(x => x.type == 'donut')">
            <div class="d-flex align-items-center justify-content-between">
              <b-icon icon="pie-chart"></b-icon>
              {{ $t('grafico-rosca') }}
            </div>
          </b-button>
        </div>
        
        <div class="modal-charts">
          <div class="d-inline-flex align-items-start">
            <h6 class="mb-4">{{ charts.selectedChart.title }} - {{ charts.targetData.title }}</h6>
            <div class="d-inline-flex align-items-center">
              <b-button size="sm" variant="transparent" class="d-inline-flex m-0 p-0 mx-1" @click="() => $bvModal.show('occurrence-charts-settings')">
                <b-icon class="m-0 p-0 system-color" icon="gear-fill"></b-icon>
              </b-button>
              <span v-b-popover.hover.top="charts.selectedChart.hint" :title="$t('informacoes-grafico')">
                <b-icon class="m-0 p-0 system-color" icon="question-circle-fill"></b-icon>
              </span>
            </div>
          </div>
          <br>
          <column-chart v-if="occurrences.data?.length 
              && charts.targetData
              && charts.selectedChart?.type 
              && charts.selectedChart.type === 'column'" 
            :occurrences="occurrences.data"
            :target="charts.targetData"
            :filename="`[${$t('grafico-barra')}] ${charts.dataOptions.find(o => o.name == charts.selectedDataName)?.title } - ${moment(filters.range[0]).format('DD-MM-YYYY')} - ${moment(filters.range[1]).format('DD-MM-YYYY')}`"
          ></column-chart>
          <pizza-chart v-if="occurrences.data?.length 
              && charts.targetData
              && charts.selectedChart?.type 
              && charts.selectedChart.type === 'pizza'" 
            :occurrences="occurrences.data"
            :target="charts.targetData"
            :filename="`[${$t('grafico-pizza')}] ${charts.dataOptions.find(o => o.name == charts.selectedDataName)?.title } - ${moment(filters.range[0]).format('DD-MM-YYYY')} - ${moment(filters.range[1]).format('DD-MM-YYYY')}`"
          ></pizza-chart>
          <donut-chart v-if="occurrences.data?.length 
              && charts.targetData
              && charts.selectedChart?.type 
              && charts.selectedChart.type === 'donut'" 
            :occurrences="occurrences.data"
            :target="charts.targetData"
            :filename="`[${$t('grafico-rosca')}] ${charts.dataOptions.find(o => o.name == charts.selectedDataName)?.title } - ${moment(filters.range[0]).format('DD-MM-YYYY')} - ${moment(filters.range[1]).format('DD-MM-YYYY')}`"
          ></donut-chart>
          <stacked-chart v-if="occurrences.data?.length 
              && charts.targetData
              && charts.selectedChart?.type 
              && charts.selectedChart.type === 'stacked'" 
            :occurrences="occurrences.data"
            :target="charts.targetData"
            :filename="`[${$t('grafico-barra-empilhada')}] ${charts.dataOptions.find(o => o.name == charts.selectedDataName)?.title } - ${moment(filters.range[0]).format('DD-MM-YYYY')} - ${moment(filters.range[1]).format('DD-MM-YYYY')}`"
          ></stacked-chart>
        </div>
      </div>
    </b-modal>

    <b-modal id="occurrence-charts-settings" size="sm" :title="`${$t('configuracao-grafico')}`" centered hide-footer>
      <div class="occurrence-charts-targe-data-selection d-flex flex-column">
        <h6>{{ $t('definicao-parametros') }}</h6>
        <b-form-group class="ml-3">
          <b-form-radio v-for="(options, index) in charts.dataOptions" :key="index" v-model="charts.selectedDataName" name="chart-option" :value="options.name">{{ options.title }}</b-form-radio>
        </b-form-group>
        <hr>
        
        <div class="d-flex justify-content-end align-items-center">
          <b-button variant="outline-warning" @click="resetSelectedTargetData">{{ $t('resetar-para-padroes') }}</b-button>
          <b-button @click="selecteTargetData" variant="transparent">
            <img src="../../assets/salvar.png" alt="Salvar Ocorrência" class="printer-button" />
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal id="export-settings" size="" :title="`${$t('exportar-ocorrencias')}`" centered hide-footer @hidden="() => { occurrences.export.anotherPeriod = false; occurrences.export.exporting = false }">
      <div>
        <div>
          <b-form-checkbox
            id="export-another-period"
            v-model="occurrences.export.anotherPeriod"
            name="export-another-period"
            :value="true"
            :unchecked-value="false"
            @change="() => occurrences.export.range = filters.range"
          >
            <span v-text="$t('deseja-exportar-outro-periodo')"></span>
          </b-form-checkbox>
          <div v-if="occurrences.export.anotherPeriod" class="mt-4">
            <div>
            <search-date-picker ref="exportDatepicker" range 
              v-model="occurrences.export.range" 
              :lang="filters.lang" 
              :shortcuts="occurrences.export.shortcuts" 
              class="custom-date" 
              type="date" 
              format="DD/MM/YYYY" placeholder="Intervalo da busca" 
              range-separator=" até " 
              @clear="() => { setDefaultRangeFilter();}"  
              >
              <template v-slot:input="slotProps">
                <input type="text" v-bind="slotProps.props" v-on="slotProps.events" />
              </template>
  
              <template v-slot:icon-calendar>
                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                  <path d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z" />
                </svg>
              </template>
            </search-date-picker>
          </div>
          </div>
        </div>
        
        <br>

        <div>
          <span v-text="$t('selecione-colunas-para-exportar')"></span>
        </div>
        
        <br>

        <div class="d-flex">
          <b-form-group class="ml-3">
            <b-form-checkbox-group class="d-flex flex-wrap flex-column checkbox-group responsive-checkbox-list"
              v-model="occurrences.export.selectedColumns"
              :options="occurrences.columns.filter(x => x.title)"
              value-field="key"
              text-field="title"
              switches>
            </b-form-checkbox-group>
          </b-form-group>
        </div>

        <hr>

        <div class="export-settings d-flex justify-content-end">
          <b-button variant="outline-warning" v-b-tooltip.hover :title="$t('cancel')" class="mr-3 btn-filter-reset" @click="$bvModal.hide('export-settings')">
            {{ $t('cancel') }}
          </b-button>
          <b-button variant="warning" v-b-tooltip.hover :title="$t('export')" @click="exportFile">
            <div v-if="occurrences.export.exporting" style="width: 83px;">
              <div class="spinner-border" role="status" style="max-height: 24px;max-width: 24px;"></div>
            </div>
            <div v-else style="display: flex; align-items: center; gap: 6px;">
              <span>{{ $t('export') }}</span>
              <b-icon icon="upload" :scale="0.65"></b-icon>
            </div>
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal id="configure-table-columns" size="" :title="`${$t('configurar-colunas')}`" centered hide-footer hide-header-close @hidden="saveTableColumns(false)">
      <div class="">
        <b-form-group class="ml-3">
          <b-form-checkbox-group
            v-model="visibleColumns.selection"
            :options="visibleColumns.options"
            name="table-columns"
            stacked
            switches
            class="responsive-checkbox-list"
          ></b-form-checkbox-group>
        </b-form-group>

        <hr>

        <div class="export-settings d-flex justify-content-end">
          <b-button variant="secondary" v-b-tooltip.hover :title="$t('cancel')" class="mr-2" @click="saveTableColumns(false)">
            {{ $t('cancel') }}
          </b-button>
          <b-button variant="warning" v-b-tooltip.hover :title="$t('salvar')" @click="saveTableColumns(true)">
            {{ $t('salvar') }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import searchDatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ptbr from 'vue2-datepicker/locale/pt-br';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import xlsx from "json-as-xlsx";

import { mapState } from "vuex";
import { urlMainAPI, showError, defaultSuccess, onEventBuss } from "@/global";
import * as moment from "moment";
import { FiltersMixin } from "../mixins/filtersMixin";
import { UtilsMixin } from "../mixins/utilsMixin";
import { WaitMixin } from "../mixins/waitMixin";
import Counter from "@/components/template/Counter.vue";
import MessageBox from '../template/MessageBoxInputModal.vue';
import ManageAllOccurrences from "../manageAllOccurrences/ManageAllOccurrences.vue";
import axios from "axios";

import ColumnChart from './OccurrencesColumnChart.vue';
import PizzaChart from './OccurrencesPizzaChart.vue';
import DonutChart from './OccurrencesDonutChart.vue';
import StackedChart from './OccurrencesStackedChart.vue';

export default {
  name: "OccurrenceGrid",  
  components: { Counter, MessageBox, ManageAllOccurrences, searchDatePicker, ColumnChart, PizzaChart, DonutChart, StackedChart },
  
  mixins: [FiltersMixin, UtilsMixin, WaitMixin],

  data() {
    return {
      motivo: "",
      loadingExcelReport: false,
      loadingPdfReport: false,
      loadingSolvace: false,
      openedOccurrence: true,
      closedOccurrence: false,
      canceledOccurrence: false,
      pgdiOccurrence: false,
      period: {
        start: moment().subtract(24, "hour").format("DD/MM/YYYY"),
        end: moment().format("DD/MM/YYYY"),
      },
      systemCharacter: "",
      occurrencesType: "1",
      occurrenceSelected: [],
      wait: false,
      counter: {},
      showSolvace: false,
      showMassDelete: false,
      dropdownObserver: null,
      tableContainerObserver: null,
      activeTimeouts: [],
      windowHeight: window.innerHeight,
      pixelRatio: window.devicePixelRatio || 1,
      injectedInputs: new WeakMap(),

      visibleColumns: {
        previousSelection: [],
        selection: [],
        options: [
          { text: this.$t('data'), value: 'data' },
          { text: this.$t('turno'), value: 'turno' },
          { text: this.$t('processo'), value: 'processo' },
          { text: this.$t('status-0'), value: 'status' },
          { text: this.$t('periodo-0'), value: 'periodo' },
          { text: this.$t('responsavel'), value: 'responsavel' },
          { text: this.$t('motivo'), value: 'motivo' },
          { text: this.$t('equipamento'), value: 'equipamento' },
          { text: this.$t('indicador-relacionado'), value: 'indicador' },
          { text: this.$t('responsibleForAction'), value: 'responsavel-acao' },
          { text: this.$t('actionStatus'), value: 'status-acao' },
          { text: this.$t('cancelado-por'), value: 'cancelado-por' },
        ]
      },
      filters: {
        ref: null,
        lang: ptbr,
        defaultRange: [moment().subtract(24, 'hours').toDate(), moment().toDate()],
        shortcuts: [
          { text: "7 dias", onClick: () => { this.filters.range = [moment().subtract(6, "days").toDate(), moment().toDate()]; this.loadOccurrenceByTime(); } },
          { text: "15 dias", onClick: () => { this.filters.range = [moment().subtract(14, "days").toDate(), moment().toDate()]; this.loadOccurrenceByTime(); } },
          { text: "30 dias", onClick: () => { this.filters.range = [moment().subtract(29, "days").toDate(), moment().toDate()]; this.loadOccurrenceByTime(); } },
          { text: "90 dias", onClick: () => { this.filters.range = [moment().subtract(89, "days").toDate(), moment().toDate()]; this.loadOccurrenceByTime(); } },
          { text: "180 dias", onClick: () => { this.filters.range = [moment().subtract(179, "days").toDate(), moment().toDate()]; this.loadOccurrenceByTime(); } },
          { text: "365 dias", onClick: () => { this.filters.range = [moment().subtract(364, "days").toDate(), moment().toDate()]; this.loadOccurrenceByTime(); } },
        ],
        range: [],
        selected: {
          creationDate: [],
          workshift: [],
          processName: [],
          statusDescription: [],
          workshiftDescription: [],
          responsibleName: [],
          reason: [],
          equipmentName: [],
          indicatorName: [],
          responsibleForAction: [],
          actionStatus: [],
          userThatCancel: [],
          occurrenceType: [],
        },
      },
      occurrenceToSummarize: null,
      summarizedReasons: [],
      occurrences: {
        options: {
          columnHiddenOption: { defaultHiddenColumnKeys: ['id', 'system'], },
          columnWidthResizeOption: { enable: true, minWidth: 10, },
          sortOption: { 
            multipleSort: true, 
            // sortAlways: true, 
            sortChange: (params) => {
              if(Object.values(params).filter(x => x != '').length == 0) {
                this.applyFilters(); // reset sort mantendo filtros de coluna e busca
              } else {
                Object.keys(params).forEach(key => {
                  this.occurrences.data.sort((a,b) => {
                    if (params[key] === "asc") {
                      return ('' + a[key]).localeCompare(b[key], "br", { ignorePunctuation: true });
                    } else if (params[key] === "desc") {
                      return ('' + b[key]).localeCompare(a[key], "br", { ignorePunctuation: true });
                    } else {
                      return 0;
                    }
                  })
                });
              }
              
            } 
          },
          virtualScrollOption: { enable: true, },
          checkboxOption: {
            selectedRowChange: ({ selectedRowKeys }) => { this.occurrences.selectedRows = selectedRowKeys; },
            selectedAllChange: ({ selectedRowKeys }) => { this.occurrences.selectedRows = selectedRowKeys; },
          },
          eventCustomOption: {
            bodyRowEvents: ({ row }) => {
              return {
                dblclick: () => {
                  const occurrence = this.occurrences.originalData.find(o => o.id == row.id)
                  if(occurrence) {
                    this.occurrenceSelected = occurrence;
                    this.$bvModal.show("UntratedOccurrences");
                  }
                },
              };
            },
          }
        },
        originalData: [],
        transformedData: [],
        data: [],
        responsibles: [],
        columns: [
          { field: "", key: 'checkbox', type: 'checkbox', width: 73, align: "center" },
          { field: "", key: 'action-row', width: 73, align: "center",
            // JSX
            renderBodyCell: ({row}) => {
              return (
                <b-button variant="link" class="action-row--button" onClick={() => this.showOccurrenceSummary(row['id'])}>
                  <img
                    src={require('@/assets/criarocorrencia.png')}
                    alt={this.$t('adicionar-nova-linha')}
                    title={this.$t('adicionar-nova-linha')}
                  />
                </b-button>
              );
            }
          },
          { field: "id", key: 'id', width: 0 },
          { field: "system", key: 'system', width: 0 },
          { field: "creationDate", key: 'data', title: this.$t('data'), align: "center", sortBy: "", width: 155, ellipsis: { lineClamp: 1 },
            filter: {
              filterList: [],
              isMultiple: true,
              filterConfirm: (filterList) => this.filterConfirm(filterList, 'creationDate'),
              filterReset: () => this.filterReset('creationDate'),
            }
          },
          { field: "occurrenceType", key: 'tipo-ocorrencia', title: this.$t('tipo-gatilho'), align: "center", sortBy: "", width: 175, ellipsis: { lineClamp: 1 },
            filter: {
              filterList: [],
              isMultiple: true,
              filterConfirm: (filterList) => this.filterConfirm(filterList, 'occurrenceType'),
              filterReset: () => this.filterReset('occurrenceType'),
            },
            renderBodyCell: ({ row }) => {
              return (
                <span title={row.triggerDescription} style="cursor: default;">
                  {row.occurrenceType}
                </span>
              );
            }
          },
          { field: "workshiftDescription", key: 'turno', title: this.$t('turno'), align: "center", sortBy: "", width: 115, ellipsis: { lineClamp: 1 },
            filter: {
              filterList: [],
              isMultiple: true,
              filterConfirm: (filterList) => this.filterConfirm(filterList, 'workshiftDescription'),
              filterReset: () => this.filterReset('workshiftDescription'),
            }
          },
          { field: "responsibleName", key: 'responsavel', title: this.$t('responsavel'), align: "left", sortBy: "", width: 200, ellipsis: { lineClamp: 1 },
            filter: {
              filterList: [],
              isMultiple: true,
              filterConfirm: (filterList) => this.filterConfirm(filterList, 'responsibleName'),
              filterReset: () => this.filterReset('responsibleName'),
            }
          },
          { field: "processName", key: 'processo', title: this.$t('processo'), align: "left", sortBy: "", width: 155, ellipsis: { lineClamp: 1 },
            filter: {
              filterList: [],
              isMultiple: true,
              filterConfirm: (filterList) => this.filterConfirm(filterList, 'processName'),
              filterReset: () => this.filterReset('processName'),
            }
          },
          { field: "statusDescription", key: 'status', title: this.$t('status-0'), align: "center", sortBy: "", width: 155, ellipsis: { lineClamp: 1 },
            filter: {
              filterList: [],
              isMultiple: true,
              filterConfirm: (filterList) => this.filterConfirm(filterList, 'statusDescription'),
              filterReset: () => this.filterReset('statusDescription'),
            }
          },
          { field: "equipmentName", key: 'equipamento', title: this.$t('equipamento'), align: "left", sortBy: "", width: 200, ellipsis: { lineClamp: 1 },
            filter: {
              filterList: [],
              isMultiple: true,
              filterConfirm: (filterList) => this.filterConfirm(filterList, 'equipmentName'),
              filterReset: () => this.filterReset('equipmentName'),
            }
          },
          { field: "indicatorName", key: 'indicador', title: this.$t('indicador-relacionado'), align: "left", sortBy: "", width: 200, ellipsis: { lineClamp: 1 },
            filter: {
              filterList: [],
              isMultiple: true,
              filterConfirm: (filterList) => this.filterConfirm(filterList, 'indicatorName'),
              filterReset: () => this.filterReset('indicatorName'),
            }
          },
          { field: "reason", key: 'motivo', title: this.$t('motivo'), align: "left", sortBy: "", width: 200, ellipsis: { lineClamp: 1 },
            filter: {
              filterList: [],
              isMultiple: true,
              filterConfirm: (filterList) => this.filterConfirm(filterList, 'reason'),
              filterReset: () => this.filterReset('reason'),
            }
          },
          { field: "actionDescription", key: 'acao', title: this.$t('acao'), align: "left", sortBy: "", width: 200, ellipsis: { lineClamp: 1 },
            filter: {
              filterList: [],
              isMultiple: true,
              filterConfirm: (filterList) => this.filterConfirm(filterList, 'actionDescription'),
              filterReset: () => this.filterReset('actionDescription'),
            }
          },
          { field: "responsibleForAction", key: 'responsavel-acao', title: this.$t('responsibleForAction'), align: "left", sortBy: "", width: 200, ellipsis: { lineClamp: 1 },
            filter: {
              filterList: [],
              isMultiple: true,
              filterConfirm: (filterList) => this.filterConfirm(filterList, 'responsibleForAction'),
              filterReset: () => this.filterReset('responsibleForAction'),
            }
          },
          { field: "actionStatus", key: 'status-acao', title: this.$t('actionStatus'), align: "left", sortBy: "", width: 155, ellipsis: { lineClamp: 1 },
            filter: {
              filterList: [],
              isMultiple: true,
              filterConfirm: (filterList) => this.filterConfirm(filterList, 'actionStatus'),
              filterReset: () => this.filterReset('actionStatus'),
            }
          },
          { field: "userThatCancel", key: 'cancelado-por', title: this.$t('cancelado-por'), align: "left", sortBy: "", width: 200, ellipsis: { lineClamp: 1 },
            filter: {
              filterList: [],
              isMultiple: true,
              filterConfirm: (filterList) => this.filterConfirm(filterList, 'userThatCancel'),
              filterReset: () => this.filterReset('userThatCancel'),
            }
          },
        ],
        selectedRows: [],
        search: null,
        export: {
          type: null,
          selectedColumns: [],
          anotherPeriod: false,
          range: [],
          shortcuts: [
            { text: "7 dias", onClick: () => { this.occurrences.export.range = [moment().subtract(6, "days").toDate(), moment().toDate()]; } },
            { text: "15 dias", onClick: () => { this.occurrences.export.range = [moment().subtract(14, "days").toDate(), moment().toDate()]; } },
            { text: "30 dias", onClick: () => { this.occurrences.export.range = [moment().subtract(29, "days").toDate(), moment().toDate()]; } },
            { text: "90 dias", onClick: () => { this.occurrences.export.range = [moment().subtract(89, "days").toDate(), moment().toDate()]; } },
            { text: "180 dias", onClick: () => { this.occurrences.export.range = [moment().subtract(179, "days").toDate(), moment().toDate()]; } },
            { text: "365 dias", onClick: () => { this.occurrences.export.range = [moment().subtract(364, "days").toDate(), moment().toDate()]; } },
          ],
          exporting: false
        }
      },
      charts: {
        selectedDataName: null,
        targetData: null,
        dataOptions: [
          { name: 'statusDescription', title: this.$t('status-0') },
          { name: 'processName', title: this.$t('processo') },
          { name: 'productionUnitName', title: this.$t('unity') },
          { name: 'indicatorName', title: this.$t('indicador-relacionado') },
          { name: 'reason', title: this.$t('motivo') }
        ],
        chartsOptions: [
          { type: 'column', title: this.$t('grafico-barra'), hint: 'O gráfico de barras mostra uma barra para cada processo, onde seu topo indica a quantidade total de ocorrências no processo em questão.' },
          { type: 'pizza', title: this.$t('grafico-pizza'), hint: 'O gráfico de pizza mostra um diagrama circular em que os valores de cada categoria estatística representada são proporcionais às respectivas medidas dos ângulo.' },
          { type: 'stacked', title: this.$t('grafico-barra-empilhada'), hint: 'O gráfico de barras empilhadas exibe a distribuição de diferentes dados analíticos dentro de cada barra, representando a contribuição de cada dado ao total.'  },
          { type: 'donut', title: this.$t('grafico-rosca'), hint: 'O gráfico de rosca mostra a proporção de diferentes dados analíticos em relação ao total, com cada segmento representa uma categoria específica.'  },
        ],
        selectedChart: null,
      }
    };
  },

  computed: {
    ...mapState(["user", "system"]),
    tableMaxHeight() {
      return 'calc(100vh - 210px)';
    },
  },

  methods: {
    moment: moment,

    recebe(data) {
      this.motivo = data;
    },

    loadCounterOccurrences() {
      axios.get(`${urlMainAPI}/getcounteroccurrence`).then((res) => {
        this.counter = res.data;
      });
    },

    closeForm() {
      let form = this.nameForm ? this.nameForm : "UntratedOccurrences"
      this.$bvModal.hide(form);
    },

    checkUserPermission() {
      const closeGeneralOccurrence = this.user.Permissions.fecharocorrenciageral;
      const solvacePermission = this.user.Permissions.enviarocorrenciasparasolvace;
      const cancelOccurrencePermission = this.user.Permissions.cancelarocorrencia;

      if (closeGeneralOccurrence != undefined && cancelOccurrencePermission != undefined) {
        if (closeGeneralOccurrence.allowed == true && cancelOccurrencePermission.allowed == true) {
          this.showMassDelete = true
        }
      }

      if (solvacePermission != undefined) {
        if (solvacePermission.allowed == true) {
          this.showSolvace = true
        }
      }
    },

    async cancelMultiplesOccurrences() {
  // 1) Valida seleção
  if (this.occurrences.selectedRows.length <= 0) {
    showError(this.$t('sem-occorrencias-selecionadas'));
    console.error(this.$t('sem-occorrencias-selecionadas'));
    return;
  }

  // 2) Valida motivo
  if (!this.motivo.trim()) {
    showError(this.$t('necessario-informar-o-motivo-do-cancelamento'));
    return;
  }

  // 3) Prepara payload
  const occurrencesToCancel = this.occurrences.originalData.filter(o =>
    this.occurrences.selectedRows.includes(o.id)
  );

  occurrencesToCancel.forEach(occ => {
    // a) Atualiza descrição
    occ.description = `${occ.description} | Cancelada: ${this.motivo}`;

    // b) Default responsável
    if (!occ.responsibleId) {
      occ.responsibleId = 1;
      occ.responsibleName = "Administrador";
    }


    
    // Cria ou atualiza o reasonContent mantendo a estrutura existente
    let reasonContent = {
          mainResponsibleId: null, // Será preenchido com o original
          reasons: [{
            id: 0,
            description: this.motivo,
            date: moment().format("YYYY-MM-DD HH:mm:ss")
          }],
          occurrenceHandleBy: {
            id: this.user.Id,
            name: this.user.FullName,
            email: this.user.Email || "",
            unitId: this.user.UnitId
          },
          auxResponsiblesId: [],
          userThatCancel: {
            id: this.user.Id,
            name: this.user.FullName,
            email: this.user.Email,
            system: this.user.onlineType[0],
            unitId: this.user.UnitId,
            date: moment().format("YYYY-MM-DD HH:mm:ss")
          }
        };

        // Se já existir um reasonContent, preserva os dados existentes
        if (occ.reasonContent) {
          try {
            let existingContent = typeof occ.reasonContent === 'string'
              ? JSON.parse(occ.reasonContent)
              : occ.reasonContent;

            reasonContent = {
              ...existingContent,
              reasons: [...(existingContent.reasons || []), reasonContent.reasons[0]],
              // Preserva o occurrenceHandleBy existente ou usa o usuário atual
              occurrenceHandleBy: existingContent.occurrenceHandleBy || reasonContent.occurrenceHandleBy,
              auxResponsiblesId: existingContent.auxResponsiblesId || [],
              userThatCancel: reasonContent.userThatCancel
            };
          } catch (e) {
            console.error('Erro ao fazer parse do reasonContent existente:', e);
          }
        }

        occ.reasonContent = JSON.stringify(reasonContent);

    // c) Garante responsibleUnitId (pra FK não quebrar)
    occ.responsibleUnitId = occ.productionUnitId;

    // d) Serializa content e reasonContent
    if (occ.content && typeof occ.content !== "string") {
      occ.content = JSON.stringify(occ.content);
    }
    if (occ.reasonContent && typeof occ.reasonContent !== "string") {
      occ.reasonContent = JSON.stringify(occ.reasonContent);
    }
  });

  // 4) Chama a API
  const url = `${urlMainAPI}/sendOccurrencesToCancel`;
  try {
    await axios.post(url, occurrencesToCancel);
    defaultSuccess(this.$t('cancelamento-massa-sucesso'));
    this.occurrences.search = null;
    await this.loadOccurrence();
  } catch (e) {
    showError(this.$t('cancelamento-massa-erro'));
    console.error(e);
  }

  // 5) Fecha modal
  this.$bvModal.hide('confirmCancelAll');
  this.closeForm();
},


    async sendToSolvace() {
      if (this.showSolvace == false) {
        showError(this.$t('sem-permissoes-para-acao'));
        console.error(this.$t('sem-permissoes-para-acao'))
        return;
      }

      else if (this.occurrences.selectedRows.length <= 0) {
        showError(this.$t('sem-occorrencias-selecionadas'));
        console.error(this.$t('sem-occorrencias-selecionadas'))
        return;
      }

      this.$bvModal.show('confirmSendSolvace')
    },

    async confirmSendSolvace() {
      this.loadingSolvace = true

      const url = `${urlMainAPI}/sendOccurrencesToSolvace`;

      const occurrencesToSend = this.occurrences.originalData.filter(occurrence => {
        return this.occurrences.selectedRows.includes(occurrence.id)
      });

      await axios.post(url, occurrencesToSend).then(() => {
        this.loadingSolvace = false
        defaultSuccess(this.$t('enviado-ao-solvace-sucesso'));
        this.loadOccurrence();
      }).catch((e) => {
        this.loadingSolvace = false
        showError(this.$t('enviado-ao-solvace-erro'))
        console.error(e)
      })
    },

    changeOccurrenceTypes() {
      if (
        !this.openedOccurrence &&
        !this.closedOccurrence &&
        !this.canceledOccurrence
      ) {
        this.occurrences.originalData = [];
        this.occurrences.transformedData = [];
        this.occurrences.data = [];
        return;
      }

      this.occurrencesType =
        `${this.openedOccurrence == true ? "1" : ""}` +
        `${this.closedOccurrence == true ? "2" : ""}` +
        `${this.canceledOccurrence == true ? "3" : ""}`;

      this.loadOccurrence();
    },

    loadOccurrenceByTime() {
      if (this.wait) return;
      this.$refs.datepicker.closePopup();
      
      defaultSuccess(this.$t('buscando-ocorrencias'));
      
      this.period.start = moment(this.filters.range[0]).format("DD/MM/YYYY");
      this.period.end = moment(this.filters.range[1]).format("DD/MM/YYYY");

      this.loadOccurrence();
    },

    setDefaultRangeFilter() { this.filters.range = this.filters.defaultRange; },

    search() {
      // Busca e filtros de coluna compoem no applyFilters()
      this.applyFilters();
    },

    onHidden_OccurrenceDigestModal() {
      this.occurrenceToSummarize = null;
      this.summarizedReasons = [];
    },

    showOccurrenceSummary(targetId) {
      if(targetId) {
        const target = this.occurrences.originalData.find(x => x.id == parseInt(targetId));
        if(typeof target.content === 'string') {
          target.content = JSON.parse(target.content);
        }
        this.occurrenceToSummarize = target;
        this.summarizedReasons = this.getTransformedReasons(this.occurrenceToSummarize)
        this.$bvModal.show('occurrence-summary');
      }
    },

    async getResponsiblesByUnits(units) {
      if(units && units.length) {
        const responsibles = [];
        for (const unit of units) {
          const response = await axios.get(`${urlMainAPI}/getresponsiblesbyunit/${unit}`)
          responsibles.push(response.data.responsibleList);
        }
        return responsibles.flat();
      } else {
        return []
      }
    },

    transformOccurrence(occurrence) {
      if(typeof occurrence.content === 'string') {
        occurrence.content = JSON.parse(occurrence.content);
      }

      if(typeof occurrence.reasonContent === 'string') {
        occurrence.reasonContent = JSON.parse(occurrence.reasonContent);
      }
      
      const triggerName = occurrence.content.triggerName || 'MAN';

      let transformedObject = {
        id: occurrence.id,
        system: occurrence.system == "G" ? "GDI" : "PGDI",
        creationDate: this.moment(occurrence.creationDate).format('DD/MM/YYYY HH:mm:ss'),
        workshift: occurrence.workshift == '4' ? 'Dia' : occurrence.workshift,
        processName: occurrence.content.processName,
        statusDescription: occurrence.statusDescription,
        workshiftDescription: occurrence.workshiftDescription,
        responsibleName: occurrence.responsibleName,
        equipmentName: occurrence.content.equipmentName || 'Não informado',
        indicatorName: occurrence.indicatorName,
        productionUnitId: occurrence.productionUnitId,
        productionUnitName: occurrence.productionUnitName,
        overdue: parseInt(occurrence.deadlineInDays || 0) < 0,
        reason: '-',
        reasonArray: [], // Novo campo para armazenar array de motivos
        responsibleForAction: '-',
        actionDescription: '-',
        actionStatus: '-',
        userThatCancel: '-', // Novo campo para armazenar quem cancelou
        occurrenceType: triggerName,
        triggerDescription: triggerName === 'MAN' ? this.$t('tooltip-origem-manual') : this.$t('tooltip-origem-gatilho'),
      }

      if (!transformedObject.workshiftDescription || transformedObject.workshiftDescription === undefined) {
        const workshiftId = transformedObject.workshift;
        if (this.occurrences.workshiftDescriptions && this.occurrences.workshiftDescriptions[workshiftId]) {
          transformedObject.workshiftDescription = this.occurrences.workshiftDescriptions[workshiftId];
        } else {
          if (workshiftId === '1') transformedObject.workshiftDescription = this.$t('Turno A');
          else if (workshiftId === '2') transformedObject.workshiftDescription = this.$t('Turno B');
          else if (workshiftId === '3') transformedObject.workshiftDescription = this.$t('Turno C');
          else if (workshiftId === '4' || workshiftId === 'Dia') transformedObject.workshiftDescription = this.$t('Dia');
          else transformedObject.workshiftDescription = workshiftId;
        }
      }

      if(Array.isArray(occurrence.reasonContent?.reasons)) {
        const reasons = occurrence.reasonContent.reasons.map(x => x.title?.replace(/Motivos de falhas > /ig, ''));
        transformedObject.reason = reasons.join('; ');
        transformedObject.reasonArray = reasons; // Armazena array de motivos

        transformedObject.responsibleForAction = [...new Set(occurrence.reasonContent.reasons
          .map(x => Array.isArray(x.actions)  ? x.actions.map(a => a.responsableId).join(';')  : null)
          .filter(x => x != null).join(';').split(';'))].join(';');
        
        transformedObject.actionDescription = occurrence.content.actionsList?.map(a => a.action).filter(Boolean).join('; ') || '-';
        transformedObject.actionStatus =  occurrence.content.actionsList?.map(action => action.status || 'Em Andamento').join('; ');

        if (occurrence.statusId === 1) {
          transformedObject.userThatCancel = '-';
        } else if (occurrence.reasonContent) {
          if (occurrence.reasonContent.userThatCancel) {
            transformedObject.userThatCancel = occurrence.reasonContent.userThatCancel.name || '-';
          } else if (occurrence.reasonContent.canceledBy) {
            transformedObject.userThatCancel = occurrence.reasonContent.canceledBy.name || '-';
          } else {
            transformedObject.userThatCancel = occurrence.responsibleName || '-';
          }
        }
      }

      // console.log('>> Original', occurrence)
      // console.log('>> Transformado', transformedObject)
      return transformedObject;
    },

    async fetchWorkshiftDescription(workshiftId) {
      try {
        const url = `${urlMainAPI}/getworkshift`;
        const response = await axios.get(url);
        
        let workshifts = [];
        
        if (response.data) {
          if (typeof response.data === 'string') {
            try {
              workshifts = JSON.parse(response.data);
            } catch (parseError) {
              console.error('Erro ao fazer parse da resposta:', parseError);
              workshifts = response.data;
            }
          } else {
            workshifts = response.data;
          }
          
          if (!Array.isArray(workshifts)) {
            console.error('A resposta não é um array de turnos:', workshifts);
            return null;
          }
          
          // Encontrar o turno pelo ID
          const workshift = workshifts.find(w => w.id.toString() === workshiftId.toString());
          if (workshift) {
            return workshift.description;
          }
        }
        return null;
      } catch (error) {
        console.error('Erro ao buscar descrição do turno:', error);
        return null;
      }
    },

    async fetchResponsibles(targetData) {
      const units = [...new Set(targetData.map(x => x.productionUnitId))];
      const responsibles = await this.getResponsiblesByUnits(units)

      return responsibles;
    },

    async loadResponsibles() {
      this.occurrences.responsibles = await this.fetchResponsibles(this.occurrences.transformedData)
      this.occurrences.transformedData.forEach(item => {
        const responsible = this.occurrences.responsibles.filter(x => x.id == parseInt(item.responsibleForAction));
        item.responsibleForAction = responsible.length ? responsible[0].name : '-';
      });
    },

    async fetchOccurrences(range, occurrencesType) {
      let result = {
        originalData: null,
        transformedData: null
      }

      try {
        let startDate = moment(range[0], "DD/MM/YYYY").format("YYYY-MM-DD");
        let endDate = moment(range[1], "DD/MM/YYYY").format("YYYY-MM-DD") + ' 23:59:59';
        const url = `${urlMainAPI}/getocurrencegrid/${this.systemCharacter}/${this.user.UnitId}/${occurrencesType}/${startDate}/${endDate}/${this.pgdiOccurrence}`;
        
        const response = await this.$http.get(url);
        if (response.data.allOccurrenceList) {
          result.originalData = response.data.allOccurrenceList
          result.transformedData = result.originalData.map(this.transformOccurrence)

          const responsibles = await this.fetchResponsibles(result.transformedData)
          result.transformedData.forEach(item => {
            const responsible = responsibles.filter(x => x.id == parseInt(item.responsibleForAction));
            item.responsibleForAction = responsible.length ? responsible[0].name : '-';
          });
        }

        return result;
      } catch (error) {
        console.log(error);
        return result;
      }
    },

    async loadOccurrence() {
      this.wait = true;
     
      try {
        // Carregar as descrições dos turnos antes de carregar as ocorrências
        await this.loadWorkshiftDescriptions();
        
        const occurrences = await this.fetchOccurrences([this.period.start, this.period.end], this.occurrencesType)
        
        if (occurrences.originalData) {
          this.occurrences.responsibles = await this.fetchResponsibles(occurrences.transformedData)
          this.occurrences.originalData = occurrences.originalData;
          this.occurrences.transformedData = occurrences.transformedData
          this.occurrences.data = occurrences.transformedData.slice(0); // clone

          // Mantém os filtros de coluna e a busca ativos após o reload (ex.: ao tratar uma ocorrência)
          this.applyFilters();

          defaultSuccess(this.$t('ocorrencias-carregadas'));
        } else {
          this.occurrences.originalData = [];
          this.occurrences.transformedData = [];
          this.occurrences.data = [];

          defaultSuccess(this.$t('nao-ha-dados-para-serem-exibidos-0'));
        }

        // Esconde a coluna de quem cancelou se não houver ocorrências canceladas selecionadas
        this.$nextTick(() => {
          if (!this.canceledOccurrence) {
            this.$refs["occurrences-table"]?.hideColumnsByKeys(['cancelado-por']);
          }

          // Configurar injeção de input de busca após renderização da tabela
          this.injectFilterSearchInput();
        });

        this.wait = false;
        this.updateColumnsFilters();
        this.loadCounterOccurrences();
      } catch (error) {
        console.log(error);
        this.wait = false;
      }
    },

    // #region Filtros
    updateColumnsFilters() {
      this.occurrences.columns = this.occurrences.columns.map((column) => {
        if (column.title) {
          column.filter.filterList = this.getFilters(column.field);
        }

        return column;
      });
    },

    filterConfirm(filterList, name) {
      this.filters.selected[name] = filterList.filter((x) => x.selected).map((x) => x.value);
      this.applyFilters();
    },

    filterReset(name) {
      this.filters.selected[name] = []; 
      this.applyFilters();
    },

    getFilters(name) {
      try {
        let values = new Set();
        let transformedData = this.occurrences.data.slice(0); // clone
  
        if(name == 'actionStatus') {
          return transformedData?.length 
            ? [...new Set(transformedData.map(item => item.actionStatus.split(';').map(x => x.replace(/[^a-zA-ZáéíóúãâêîôûàèìòùçÁÉÍÓÚÃÂÊÎÔÛÀÈÌÒÙÇ ]/g, ''))).flat())]
              .map(text => ({ value: text, label: text, selected: this.filters.selected[name].includes(text) }))
            : [];
        } else {
          return transformedData?.length 
            ? transformedData
              .map(item => { 
                const value = item[name]?.toString();
                if(!value) { return null; }

                return {
                  value: value,
                  // Limita o tamanho do texto exibido em 25 caracteres
                  label: value.length > 25 ? value?.substring(0,25) + '...' : value,
                  selected: this.filters.selected[name]?.includes(value) ?? false
                }
              })
              .filter(item => {
                if(item == null) { return false; }

                // Remove duplicados
                if(values.has(item.value)) { return false; }
    
                values.add(item.value);
                return true
              })
            : [];
        }        
      } catch (error) {
        console.error(error);
        return []
      }
    },

    applyFilters() {
      let transformedData = this.occurrences.transformedData.slice(0); // clone
      for (const filter of Object.keys(this.filters.selected)) {
        if(['actionStatus'].includes(filter)) {
          if(this.filters.selected[filter].length) {
            transformedData = transformedData.filter(item => this.filters.selected[filter].some(f => item[filter].includes(f)));
          } 
        } else {
          if(this.filters.selected[filter].length) {
            transformedData = transformedData.filter(item => {
              return this.filters.selected[filter].toString().includes(item[filter].toString())
            });
          }
        }
      }

      // Aplica a busca textual sobre o resultado ja filtrado pelas colunas (filtros compoem)
      if (this.occurrences.search) {
        const term = this.occurrences.search.toLowerCase();
        transformedData = transformedData.filter(x =>
          Object.values({ ...x, id: null }).some(v => v && v.toString().toLowerCase().includes(term))
        );
      }

      this.occurrences.data = transformedData;
      this.updateColumnsFilters();
    },
    // #endregion Filtros

    showOccurrenceCharts() {
      this.resetSelectedTargetData()
      this.charts.selectedChart = this.charts.chartsOptions.find(x => x.type == 'column');
      this.$bvModal.show('occurrence-charts')
    },

    resetSelectedTargetData() {
      this.charts.selectedDataName = 'processName';
      this.charts.targetData = this.charts.dataOptions.find(x => x.name == this.charts.selectedDataName);
      this.$bvModal.hide('occurrence-charts-settings')
    },

    selecteTargetData() {
      if(this.charts.selectedDataName) {
        this.charts.targetData = this.charts.dataOptions.find(x => x.name == this.charts.selectedDataName);
        
        // Se for gráfico de motivos, ajusta os dados para usar o array de motivos
        if(this.charts.selectedDataName === 'reason') {
          this.charts.targetData = {
            ...this.charts.targetData,
            useReasonArray: true // Flag para indicar uso do array de motivos
          };
        }
      } else {
        this.charts.targetData = this.charts.dataOptions.find(x => x.name == 'processName');
      }

      this.$bvModal.hide('occurrence-charts-settings')
    },

    resetAllFilters() {
      this.occurrences.search = null;

      this.openedOccurrence = true;
      this.closedOccurrence = false;
      this.canceledOccurrence = false;

      for (const f of Object.keys(this.filters.selected)) {
        this.filters.selected[f] = [];
      }

      this.changeOccurrenceTypes(); // Atualiza a grid
    },

    openExportSettings(exportType) {
      this.occurrences.export.type = exportType
      this.occurrences.export.selectedColumns = this.occurrences.columns.filter(x => x.title).map(x => x.key)
      this.$bvModal.show('export-settings')
    },

    async exportFile() {
      const selectedColumns = this.occurrences.columns.filter(x => this.occurrences.export.selectedColumns.includes(x.key));

      this.occurrences.export.exporting = true;
      if(this.occurrences.export.type == 'pdf') {
        await this.exportPdf(selectedColumns);
      } else if(this.occurrences.export.type == 'excel') {
        await this.exportExcel(selectedColumns);
      }
      this.occurrences.export.exporting = false;
    },

    async exportExcel(selectedColumns) {
      let targetData = []
      let fileName = null;
      
      if(this.occurrences.export.anotherPeriod) {
        const occurrencesType = '1234';
        const occurrences = await this.fetchOccurrences([this.occurrences.export.range[0], this.occurrences.export.range[1]], occurrencesType)
        if (occurrences.originalData) {
          targetData = occurrences.transformedData
          fileName = `${this.$t('ocorrencias')}-${moment(this.occurrences.export.range[0]).format('DD-MM-YYYY')}--${moment(this.occurrences.export.range[1]).format('DD-MM-YYYY')}`
        }
      } else {
        targetData = this.occurrences.data;
        fileName = `${this.$t('ocorrencias')}-${moment(this.filters.range[0]).format('DD-MM-YYYY')}--${moment(this.filters.range[1]).format('DD-MM-YYYY')}`
      }

      if(targetData?.length == 0) {
        showError(this.$t('nao-ha-dados'));
        return;
      }

      try {
        this.loadingExcelReport = true;

        const settings = {
          fileName: fileName,
        };
        const data = [
          {
            sheet: this.$t('ocorrencias'),
            columns: selectedColumns.map(x => ({ label: x.title, value: x.field })),
            content: targetData
          }
        ];

        xlsx(data, settings)

        this.loadingExcelReport = false;
      } catch (error) {
        console.error(error);
        this.loadingExcelReport = false;
      }

      this.$bvModal.hide('export-settings')
    },

    async exportPdf(selectedColumns) {
      let targetData = []
      
      if(this.occurrences.export.anotherPeriod) {
        const occurrencesType = '1234';
        const occurrences = await this.fetchOccurrences([this.occurrences.export.range[0], this.occurrences.export.range[1]], occurrencesType)
        if (occurrences.originalData) {
          targetData = occurrences.transformedData
        }
      } else {
        targetData = this.occurrences.data;
      }

      if(targetData?.length == 0) {
        showError(this.$t('nao-ha-dados'));
        return;
      }

      try {
        this.loadingPdfReport = true;

        const doc = new jsPDF({
          orientation: 'landscape',
          compress: true
        });
        autoTable(doc, { 
          headStyles: { valign: 'middle' },
          head: [
            selectedColumns.map(x => x.title)
          ],
          body: targetData.map(item => selectedColumns.map(c => item[c.field])),
          // Devido ao Virtual Scroll, o conteúdo completo não é renderizado
          // html: document.querySelector('#occurrences-table table') 
        });
        doc.save('Ocorrências.pdf');
        this.loadingPdfReport = false;
      } catch (error) {
        this.loadingPdfReport = false;
      }

      this.$bvModal.hide('export-settings')
    },

    showModalTableColumns() {
      this.$bvModal.show('configure-table-columns')
    },

    saveTableColumns(save) {
      this.$bvModal.hide('configure-table-columns')

      if(save) {
        this.visibleColumns.previousSelection = this.visibleColumns.selection;

        // esconde todas as colunas
        this.$refs["occurrences-table"].hideColumnsByKeys(this.visibleColumns.options.map(o => o.value));

        // exibe a seleção
        this.$refs["occurrences-table"].showColumnsByKeys(this.visibleColumns.selection);

        // Se não houver ocorrências canceladas selecionadas, esconde a coluna de quem cancelou
        if (!this.canceledOccurrence) {
          this.$refs["occurrences-table"].hideColumnsByKeys(['cancelado-por']);
        }
      } else {
        this.visibleColumns.selection = this.visibleColumns.previousSelection;
      }
    },

    getTransformedReasons(occurrence) {
      const reasons = occurrence.reasonContent.reasons.map(r => {
        return {
          title: r.title,
          actions: r.actions.map(a => {
            return {
              name: a.action,
              status: a.status ?? 'Em andamento',
              responsible: this.occurrences.responsibles.find(x => x.id == parseInt(a.responsableId))?.name
            }
          })
        }
      })

      return reasons;
    },

    injectFilterSearchInput() {
      // Função para injetar o input de busca em um dropdown
      const injectSearchInput = (dropdown) => {
        // Verificar se já tem o input de busca (usando WeakMap)
        if (this.injectedInputs.has(dropdown)) return;

        // Verificar se é um dropdown de filtro múltiplo
        const hasMultipleItems = dropdown.querySelector('.ve-dropdown-items-multiple');
        if (!hasMultipleItems) return;

        // Encontrar o container de itens
        const itemsContainer = dropdown.querySelector('.ve-dropdown-items');
        if (!itemsContainer) return;

        // Criar o wrapper do input
        const searchWrapper = document.createElement('div');
        searchWrapper.className = 'filter-search-wrapper';

        // Criar o input de busca
        const searchInput = document.createElement('input');
        searchInput.type = 'text';
        searchInput.className = 'filter-search-input';
        searchInput.placeholder = 'Buscar opção';
        searchInput.setAttribute('aria-label', 'Buscar nas opções de filtro');

        // Handler de filtro (salvar referência para poder remover depois)
        const filterHandler = (event) => {
          const searchTerm = event.target.value.toLowerCase().trim();
          const checkboxItems = dropdown.querySelectorAll('.ve-dropdown-items-li');

          checkboxItems.forEach(item => {
            const label = item.querySelector('.ve-checkbox-label');
            if (label) {
              const text = label.textContent.toLowerCase().trim();
              const shouldShow = !searchTerm || text.includes(searchTerm);

              if (shouldShow) {
                item.style.cssText = 'display: flex !important; visibility: visible !important; height: auto !important;';
              } else {
                item.style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important;';
              }
            }
          });
        };

        // Adicionar evento de input
        searchInput.addEventListener('input', filterHandler);

        searchWrapper.appendChild(searchInput);

        // Inserir no início do dropdown, antes dos itens
        itemsContainer.insertBefore(searchWrapper, itemsContainer.firstChild);

        // Marcar como injetado e salvar referências para limpeza
        this.injectedInputs.set(dropdown, {
          input: searchInput,
          handler: filterHandler,
          wrapper: searchWrapper
        });

        // Focar no input com cleanup do timeout
        const timeoutId = setTimeout(() => {
          if (searchInput && document.contains(searchInput)) {
            searchInput.focus();
          }
          // Remover da lista de timeouts ativos
          const index = this.activeTimeouts.indexOf(timeoutId);
          if (index > -1) this.activeTimeouts.splice(index, 1);
        }, 50);

        this.activeTimeouts.push(timeoutId);
      };

      // Observar mudanças no container da tabela
      this.$nextTick(() => {
        const tableContainer = document.querySelector('#occurrences-table');
        if (!tableContainer) return;

        // Observer para mudanças de atributos nos dropdowns
        this.dropdownObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const element = mutation.target;
              if (element.classList.contains('ve-dropdown-dd-show')) {
                injectSearchInput(element);
              }
            }
          });
        });

        // Observer para detectar novos dropdowns sendo adicionados ao DOM
        this.tableContainerObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) { // Element node
                // Verificar se o nó é um dropdown ou contém dropdowns
                const dropdowns = node.classList?.contains('ve-dropdown-dd')
                  ? [node]
                  : node.querySelectorAll?.('.ve-dropdown-dd') || [];

                dropdowns.forEach(dropdown => {
                  this.dropdownObserver.observe(dropdown, {
                    attributes: true,
                    attributeFilter: ['class']
                  });
                });
              }
            });
          });
        });

        // Observar o container da tabela para detectar novos dropdowns
        this.tableContainerObserver.observe(tableContainer, {
          childList: true,
          subtree: true
        });

        // Observar dropdowns existentes
        const existingDropdowns = tableContainer.querySelectorAll('.ve-dropdown-dd');
        existingDropdowns.forEach(dropdown => {
          this.dropdownObserver.observe(dropdown, {
            attributes: true,
            attributeFilter: ['class']
          });
        });
      });
    },

    async loadWorkshiftDescriptions() {
      try {
        const url = `${urlMainAPI}/getworkshift`;
        const response = await axios.get(url);
        
        let workshifts = [];
        
        if (response.data) {
          if (typeof response.data === 'string') {
            try {
              workshifts = JSON.parse(response.data);
            } catch (parseError) {
              console.error('Erro ao fazer parse da resposta:', parseError);
              workshifts = response.data;
            }
          } else {
            workshifts = response.data;
          }
          
          if (!Array.isArray(workshifts)) {
            console.error('A resposta não é um array de turnos:', workshifts);
            return;
          }
          
          // Criar um objeto com as descrições dos turnos
          this.occurrences.workshiftDescriptions = {};
          workshifts.forEach(workshift => {
            this.occurrences.workshiftDescriptions[workshift.id] = workshift.description;
          });
        }
      } catch (error) {
        console.error('Erro ao buscar descrições dos turnos:', error);
      }
    },
  },

  created() {
    this.checkUserPermission();
    this.systemCharacter = this.system == "GDI" ? "G" : "P";
    this.loadOccurrence();
  },

  mounted() {
    this.setDefaultRangeFilter()

    this.visibleColumns.previousSelection = this.visibleColumns.selection = this.visibleColumns.options.map(o => o.value);

    // Sistema PGDI não filtra por unidade
    if(this.system == 'PGDI') {
      this.charts.dataOptions = this.charts.dataOptions.filter(o => o.name != 'productionUnitName');
    }

    onEventBuss("reloadGridOccurrence", this.loadOccurrence);

    // Injetar input de busca nos filtros das colunas
    this.injectFilterSearchInput();

    this._onResize = () => {
      this.windowHeight = window.innerHeight;
      this.pixelRatio = window.devicePixelRatio || 1;
    };
    window.addEventListener('resize', this._onResize);
  },

  destroyed() {
    this.wait = false;

    if (this._onResize) window.removeEventListener('resize', this._onResize);

    // Limpar todos os timeouts ativos
    this.activeTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
    this.activeTimeouts = [];

    // Limpar o observer de dropdowns
    if (this.dropdownObserver) {
      this.dropdownObserver.disconnect();
      this.dropdownObserver = null;
    }

    // Limpar o observer do container
    if (this.tableContainerObserver) {
      this.tableContainerObserver.disconnect();
      this.tableContainerObserver = null;
    }
  },
};
</script>

<style>

.btn .b-icon.bi, .nav-link .b-icon.bi, .dropdown-toggle .b-icon.bi, .dropdown-item .b-icon.bi {
  font-size: 178%;
  vertical-align: text-bottom;
}

.system-color { color: #ff5f00; }
.btn-filter-reset {
  color: #ff5f00;
  border-color: #ff5f00;
}
.btn-filter-reset:hover,
.btn-filter-reset:active {
  background-color: #ff5f00 !important;
  color: #ffffff !important;
}

/* Filter search input styles */
.filter-search-wrapper {
  padding: 0.2rem 0.4rem;
}

.filter-search-input {
  width: 100%;
  border: 1px solid #c7c7c7;
  border-radius: 0.2rem;
  padding: 0.2rem 0.35rem;
}

/* Responsive checkbox list for filter modals */
.responsive-checkbox-list {
  max-height: min(70vh, 35rem) !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.search-input-group .input-group-prepend .input-group-text {
  background-color: transparent;
  border-right: 0;
  border-color: #ff5f00;
  color: #ff5f00;
}
.search-input-group input {
  border-left: 0 !important;
  width: 400px;
  max-width: 400px;
}

.occurrence-charts-types {
  width: 210px;
  padding-right: 25px;
  margin-right: 15px;
  border-right: 1px solid #cccccc;
}

.modal-charts {
  width: calc(1106px - 210px - 15px);
}

.occurrence-charts-types .btn-warning,
.occurrence-charts-types .btn-outline-warning:hover,
.occurrence-charts-targe-data-selection .btn-outline-warning:hover,
.export-settings .btn-warning {
  background-color: #ff5f00;
  color: #ffffff;
  border-color: #ff5f00;
}

.occurrence-charts-types .btn-outline-warning,
.occurrence-charts-targe-data-selection .btn-outline-warning {
  color: #ff5f00;
  border-color: #ff5f00;
}

.loadingOcc {
  display: block;
  height: 92%;
  position: absolute;
  overflow: auto;
}

.table-occurence>div:first-child {
  height: calc(100% - 68px);
}

.table-occurence>div:first-child>div:nth-child(2) {
  height: 100% !important;
  overflow-x: auto;
}

#occurrences-table {
  overflow: hidden !important;
}

#occurrences-table .ve-table-container {
  overflow: auto !important;
}

#occurrences-table .ve-table-content {
  min-width: 2200px;
}

#occurrences-table .ve-table-container::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}

#occurrences-table .ve-table-container::-webkit-scrollbar-thumb {
  background: #17a2b8;
  border-radius: 4px;
}

#occurrences-table .ve-table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-occurence>div:first-child>div:nth-child(2)>div:nth-child(2) {
  height: calc(100% - 30px) !important;
}

.table-occurence>div>div>div>div>div>span>span>div>div>div>span {
  margin-left: 5px;
}

.switchGroup label {
  font-size: 0.9em;
}

/* .tooltipMsgForVueTableDinamic>div>div>div>div>div>div>div>div>span:hover {   
  } */

li.ve-dropdown-operation {
  min-width: 150px !important;
}
</style>

<style scoped>
/* Fix dropdown filter positioning and sizing - force downward opening */
::v-deep .ve-dropdown {
  position: relative !important;
}

::v-deep .ve-dropdown-popper {
  position: fixed !important;
  z-index: 9999 !important;
}

::v-deep .ve-dropdown-popper[x-placement^="top"] {
  top: auto !important;
  bottom: auto !important;
}

::v-deep .ve-dropdown-popper[x-placement^="bottom"] {
  top: auto !important;
  bottom: auto !important;
}

::v-deep .ve-dropdown-items {
  max-height: 400px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  min-width: 250px !important;
  max-width: 500px !important;
}

::v-deep .ve-dropdown-items > * {
  max-height: none !important;
  overflow: visible !important;
}

::v-deep .ve-dropdown-items * {
  max-height: none !important;
  overflow: visible !important;
}

::v-deep .ve-dropdown-items-multiple,
::v-deep .ve-dropdown-items-multiple *,
::v-deep .ve-dropdown-items-multiple-content,
::v-deep .ve-dropdown-items-multiple-content * {
  max-height: none !important;
  overflow: visible !important;
}

::v-deep .ve-dropdown-items-li {
  white-space: normal !important;
  word-wrap: break-word !important;
  padding: 10px 15px !important;
  line-height: 1.5 !important;
  min-height: 40px !important;
  display: flex !important;
  align-items: center !important;
  overflow: visible !important;
}

::v-deep .ve-dropdown-items-li * {
  overflow: visible !important;
}

::v-deep .ve-dropdown-items-li label,
::v-deep .ve-dropdown-items-li span,
::v-deep .ve-dropdown-items-li div {
  overflow: visible !important;
  text-overflow: clip !important;
}

::v-deep .ve-dropdown-items-li .ve-checkbox {
  overflow: visible !important;
}

::v-deep .ve-dropdown-items-li .ve-checkbox-label {
  overflow: visible !important;
  white-space: normal !important;
}

/* Responsive for all zoom levels - using viewport-based sizing */
@media screen and (max-width: 1920px) {
  ::v-deep .ve-dropdown-items {
    max-height: min(50vh, 400px) !important;
  }
}

@media screen and (max-width: 1600px) {
  ::v-deep .ve-dropdown-items {
    max-height: min(45vh, 380px) !important;
  }
}

@media screen and (max-width: 1366px) {
  ::v-deep .ve-dropdown-items {
    max-height: min(40vh, 350px) !important;
  }
}

@media screen and (max-width: 1024px) {
  ::v-deep .ve-dropdown-items {
    max-height: min(35vh, 320px) !important;
  }
}

@media screen and (max-width: 960px) {
  /* Captures 200% zoom on 1920px screens (1920/2 = 960px) */
  ::v-deep .ve-dropdown-items {
    max-height: min(30vh, 250px) !important;
    max-width: 400px !important;
  }
}

@media screen and (max-width: 800px) {
  /* Captures 200% zoom on 1600px screens */
  ::v-deep .ve-dropdown-items {
    max-height: min(28vh, 220px) !important;
    max-width: 380px !important;
  }
}

@media screen and (max-width: 683px) {
  /* Captures 200% zoom on 1366px screens */
  ::v-deep .ve-dropdown-items {
    max-height: min(25vh, 200px) !important;
    max-width: 350px !important;
  }
}

@media screen and (max-width: 600px) {
  ::v-deep .ve-dropdown-items {
    max-height: min(22vh, 180px) !important;
    max-width: 320px !important;
  }
}

::v-deep .checkbox-group div {
  display: inline-flex;
  flex: 0 0 50%;
  padding-right: 25px;
}
.main-occurrence-grid {
  height: 100%;
  overflow: hidden;
}

.checkbox-pgdi {
  display: flex;
  margin-left: 30px;
  font: bold;
  font-size: x-large;
}

.check {
  margin-top: 6.5px;
}

.Selected-day {
  display: flex;
  justify-content: center;
  justify-items: center;
}

.Selected-day {
  display: flex;
  justify-content: center;
}

.reportField {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}

.spinnerConfig {
  width: 1.5rem;
  height: 1.5rem;
  margin-left: 10px;
  color: #ff5f00;
}

.printer-button {
  height: 30px;
  width: 30px;
  cursor: pointer;
}

.table-occurence {
  cursor: pointer;
  height: calc(100% - 43px);
}

.img-slot,
.in-line {
  display: flex;
  align-items: center;
  justify-items: center;
}

.switchGroup {
  display: flex;
  justify-content: flex-start;
  gap: 15px;
  min-width: 620px;
}

.float-right {
  max-height: 42px;
  cursor: pointer;
}

.occurrence-manage-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.occurrence-manage-container img,
.remove-occurrence-icon {
  height: 30px;
  width: 30px;
}

.occurrence-manage-container button {
  background-color: transparent;
  border: none;
  padding: 5px;
}


.occurrence-manage-container button:disabled {
  color: #8b8b8b;
}

.occurrence-manage-container button:enabled {
  color: #ff5f00;
}

.clean-filters {
  z-index: 1;
  position: absolute;
  top: 8px;
  left: 18rem;
  padding: 3px 6px;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #ff5e00d8;
  color: #ff5e00d8;
  background-color: white;
  border-radius: 2px;
}


.clean-filters {
  z-index: 1;
  position: absolute;
  top: 8px;
  left: 18rem;
  padding: 3px 6px;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #ff5e00d8;
  color: #ff5e00d8;
  background-color: white;
  border-radius: 2px;
}

.empty-data {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  width: 100%;
  color: #666;
  font-size: 16px;
  border: 1px solid #eee;
  border-top: 0;
}

.action-row--button img {
  max-height: 18px;
}

@media (max-width: 1160px) {
  .main-occurrence-grid {
    width: 100%;
  }
}

@media (min-width: 1160px) and (max-width: 1366px) {
  .main-occurrence-grid {
    width: 100%;
    max-width: 1366px;
  }
}

@media (min-width: 1367px) {
  .main-occurrence-grid {
    width: 100%;
  }
}
</style>
